import { GET_COO_STATISTICS_URL } from '../../services/api/coo-statistics/CooStatisticsApi';
import legacy from '../../services/api/axios';

export const get_bizdev_installation_records = async (selectedYear, selectedCountry) => {
  const initialDateClicked = {
    from: `${selectedYear}-01-01`,
    to: `${selectedYear}-12-31`,
  };

  const initialExpirationState = {
    action: 'get_bizdev_installation_records',
    ...initialDateClicked,
    country: `${selectedCountry}`,
  };
  const formData = new URLSearchParams(initialExpirationState).toString();
  try {
    // const headers = {
    //   // 'Content-Type': 'application/x-www-form-urlencoded',
    //   Authorization: `Bearer ${sessionStorage.getItem('token')}`,
    // };
    const res = await legacy.post(`${GET_COO_STATISTICS_URL}`, formData);
    if (res.data) {
      // console.log(res.data);
      return res.data;
    }
  } catch (error) {
    console.error(error);
  }
  // console.log(isLoading);
};
